import { PercentBadgeIcon } from '@heroicons/react/24/outline';

import type { PriceData } from '../../utils/pricing/types';

interface DiscountProps {
  price: PriceData;
}

export function Discount(props: DiscountProps) {
  const { price } = props;

  if (!price.firstYearDiscount || !price.firstYearValue) {
    return null;
  }

  return (
    <div className="absolute top-[-26px] left-[50%]">
      <div className="-mx-[50%] bg-primary-200 pl-2 pr-4 py-2 w-full rounded-md flex items-center gap-2">
        <PercentBadgeIcon className="size-8" />
        <div className="flex flex-col">
          <span className="text-sm font-bold text-nowrap">
            {price.firstYearDiscount}% off the first year
          </span>
          <span className="text-xs text-neutral-600 text-nowrap">
            at {price.firstYearValue} CHF instead of {price.value} CHF
          </span>
        </div>
      </div>
    </div>
  );
}
